import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, Transition as _Transition, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/placeholder.png'


const _hoisted_1 = { class: "flex w-8 h-8 rounded-full" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "block w-full rounded-full",
  src: _imports_0,
  alt: 'Avatar'
}
const _hoisted_4 = { class: "relative w-8 h-8 rounded" }
const _hoisted_5 = { class: "py-2 bg-neutral-50 text-neutral-900 rounded-2xl overflow-hidden border border-neutral-200" }
const _hoisted_6 = {
  key: 0,
  class: "px-4 py-2 mb-1 border-b border-neutral-200"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "block text-xs" }, "Connected as", -1)
const _hoisted_8 = { class: "block font-bold" }
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = { class: "flex flex-col pt-1 mt-1 border-t border-neutral-200" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "flex items-center justify-start space-x-2 font-bold w-full px-4 py-1 hover:bg-neutral-100 transition-color ease-in",
    href: "https://foundation.app/@blockschmidt",
    target: "_blank",
    rel: "noopener noreferrer"
  }, " Mint Dripversity Drop ")
], -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Claim CAMPUS Airdrop ")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "block" }, "Connecting...", -1)
const _hoisted_14 = {
  key: 1,
  class: "block"
}
const _hoisted_15 = {
  key: 2,
  class: "block"
}

import { routes } from "@/constants/";
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/vue";
import { storeToRefs } from "pinia";
import { useUserStore } from "@/store/modules/user";
import LoadingIcon from "@/components/icons/LoadingIcon.vue";
import { useSalePhase } from "@/composables/useSalePhase";


export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutHeaderAvatar',
  setup(__props) {

const { isPreSale } = useSalePhase();
const userStore = useUserStore();
const { disconnectConnectedWallet, connect } = userStore;
const { isConnected, image, displayName, connectingWallet } =
    storeToRefs(userStore);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_unref(Popover), { class: "relative pointer-events-auto" }, {
    default: _withCtx(({ open }) => [
      _createVNode(_unref(PopoverButton), { class: "flex items-center rounded-full space-x-2 cursor-pointer !outline-none bg-neutral-900/50 backdrop-blur-sm p-1 pr-3" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_unref(isConnected))
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "block w-full rounded-full",
                  src: _unref(image),
                  alt: 'Avatar'
                }, null, 8, _hoisted_2))
              : (_openBlock(), _createElementBlock("img", _hoisted_3))
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", {
              class: _normalizeClass(["absolute top-1/2 left-1 right-1 block h-[0.05rem] bg-neutral-50 transform translate-y-[0.25rem] transition-transform duration-200 ease-in-out", open && 'rotate-45 !translate-y-1/2'])
            }, null, 2),
            _createElementVNode("span", {
              class: _normalizeClass(["absolute top-1/2 left-1 right-1 block h-[0.05rem] bg-neutral-50 transform -translate-y-[0.25rem] transition-transform duration-200 ease-in-out", open && '-rotate-45 !translate-y-1/2'])
            }, null, 2)
          ])
        ]),
        _: 2
      }, 1024),
      _createVNode(_Transition, {
        "enter-active-class": "transition duration-200 ease-in-out",
        "enter-from-class": "translate-y-1 opacity-0",
        "enter-to-class": "translate-y-0 opacity-100",
        "leave-active-class": "transition duration-200 ease-in-out",
        "leave-from-class": "translate-y-0 opacity-100",
        "leave-to-class": "translate-y-1 opacity-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(PopoverPanel), { class: "absolute top-full right-0 w-60 z-10 mt-2" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                (_unref(isConnected))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _hoisted_7,
                      _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(displayName)), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("ul", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(routes).home, (to, name) => {
                    return (_openBlock(), _createElementBlock("li", { key: name }, [
                      _createVNode(_component_router_link, {
                        class: "block w-full px-4 py-1 hover:bg-neutral-100 transition-color ease-in",
                        to: to
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("ul", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      class: "flex items-center justify-start space-x-2 font-bold w-full px-4 py-1 hover:bg-neutral-100 transition-color ease-in",
                      to: "/airdrop"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("button", {
                      class: "flex items-center justify-start space-x-2 font-bold w-full px-4 py-1 hover:bg-neutral-100 transition-color ease-in",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (
                                    _unref(isConnected)
                                        ? _unref(disconnectConnectedWallet)()
                                        : _unref(connect)()
                                ), ["prevent"]))
                    }, [
                      (_unref(connectingWallet))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(LoadingIcon),
                            _hoisted_13
                          ], 64))
                        : (_unref(isConnected))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Disconnect Wallet"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_15, "Connect Wallet"))
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})